import { Button, dialog, InfiniteScroll, Progress } from "nq-component";
import BaseListPage from "../../../base/BaseListPage";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import CardView from "../../../components/common/CardView";
import Table from "../../../components/Table";
import withRouter from "../../../withRouter";
import JobApplicantsPresenter from "./JobApplicantsPresenter";
import {
  SetApplicantSchedule,
  UpdateObjectStatus,
} from "./JobApplicantFrom/FloatingForm";
import PrintPDS from "./PrintApplicant/PrintPDS";
import { GenerateApplicantCSV } from "./PrintApplicant/GenerateApplicantCSV";
import InputFactory from "../../../components/InputFactory";
import DateRangePicker from "../../../components/common/DateRangePicker";
import { Spin } from "antd";

class JobApplicantsPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new JobApplicantsPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );

    this.state = {
      objects: [],
      description: "",
      sendToAll: false,
      offices: [],
      count: 0,
      limit: 20,
      current: 1,
      isStatusClicked: false,
      isScheduleClicked: false,
      status: "",
      object: {},
      positionTitle: [],
      showTooltip: false,
      // fields: {}
    };
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const [positionTitle, allEmployee] = await Promise.all([
      findObjectUseCase().execute("position_titles"),
      findObjectUseCase().execute("employees", { keys: ["email"] }),
    ]);
    this.setState({ positionTitle, allEmployee });
    // console.log("POSITION: ", positionTitle);
  }

  // delete function
  async ScheduleApplicant(object) {
    console.log("scheduleApplicant", object);
    this.setState({ isScheduleClicked: true, object: object });
  }

  // edit function
  async UpdateStatus(object) {
    this.setState({ isStatusClicked: true, object: object });
  }

  handleViewData(object) {
    this.navigateTo(`/view/${this.getCollectionName()}/${object.id}`);
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  async handlePrintBtn(object) {
    const query = {
      where: { empID: object.id },
    };
    const [
      civilServiceBackground,
      educationalBackground,
      referenceBackground,
      workExperienceBackground,
      voluntaryWorkBackground,
      learningDevBackground,
      otherInformationBackground,
      familyBackground,
    ] = await Promise.all([
      findObjectUseCase().execute("service_eligibility", query),
      findObjectUseCase().execute("educational_background", query),
      findObjectUseCase().execute("reference_table", query),
      findObjectUseCase().execute("work_experience", query),
      findObjectUseCase().execute("voluntary_work", query),
      findObjectUseCase().execute("learning_development", query),
      findObjectUseCase().execute("other_information", query),
      findObjectUseCase().execute("family_background", query),
    ]);
    const employeeData = {
      ...object,
      civilServiceBackground,
      educationalBackground,
      referenceBackground,
      workExperienceBackground,
      voluntaryWorkBackground,
      learningDevBackground,
      otherInformationBackground,
      familyBackground,
    };
    PrintPDS({ employeeData });
  }
  handleGenerateCSV(object) {
    GenerateApplicantCSV(object);
  }

  getCollectionName() {
    return "job_applicants";
  }

  addNotices() {
    this.navigateTo(`/form/${this.getCollectionName()}/`);
  }

  submitMe() {
    upsertUseCase().execute(this.getCollectionName(), this.state);
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  handleFloatingClose(field) {
    this.setState({ [field]: false, object: {} });
  }

  handleStatusChange(data) {
    this.setState({ status: data });
  }

  // async generateCSV(objects) {
  //   this.presenter.getGenerateCSV(objects);
  // }

  handleMouseEnter = () => {
    const { selected } = this.state;
    const hasInvalidStatus =
      Array.isArray(selected) &&
      selected.some(
        (applicant) =>
          applicant.status === "Hired" || applicant.status === "Rejected"
      );
    if (hasInvalidStatus) {
      this.setState({ showTooltip: true });
    }
  };

  handleMouseLeave = () => {
    this.setState({ showTooltip: false });
  };
  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, current, limit, selected, showTooltip } =
      this.state;
    if (!schema) return <Progress />;
    // const user = this.getCurrentUser();

    if (this.state.isGenerating) {
      dialog.fire({
        html: (
          <div
            className="d-flex gap-3 flex-column align-items-center justify-content-center p-5"
            // style={{ height: "100vh" }}
          >
            <Spin size="large" />
            <p>Loading...</p>
          </div>
        ),
        footer: false,
      });
    }

    const includeFields = [
      "reference",
      "surname",
      "Firstname",
      "Middlename",
      "email",
      "createdAt",
      "status",
      "position",
      "positionTitle",
      "publication",
      "reposting",
      "typeOfApplicant",
      "placeOfOrigin",
      "placeOfAssignment",
    ];
    const includeTable = Object.keys(schema.fields).filter(
      (key) => !includeFields.includes(key)
    );

    const hasInvalidStatus =
      Array.isArray(selected) &&
      selected.some(
        (applicant) =>
          applicant.status === "Hired" || applicant.status === "Rejected"
      );
    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} Recruitment {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    {schema.collection}
                  </span>
                </p>
              </div>
              <CardView style={{ borderRadius: 0 }}>
                <div className="d-flex align-items-center justify-content-around gap-3">
                  <div className="row">
                    {Object.keys(schema.filters || {}).map((field) => {
                      let { type, ...options } = schema.filters[field];
                      return (
                        <div className="col-lg-4 p-1" key={field}>
                          <InputFactory
                            key={field}
                            type={type}
                            field={field}
                            where={{}}
                            onChange={this.presenter.onChangeFilter.bind(
                              this,
                              type
                            )}
                            {...options}
                          />
                        </div>
                      );
                    })}

                    <div
                      className="col-lg-4"
                      style={{ marginTop: "3px", marginLeft: "-9px" }}
                    >
                      <DateRangePicker
                        fields={["createdAt", "updatedAt", ""]}
                        onFilter={(filterObj) => {
                          try {
                            const update = new Date(filterObj.updatedAt.$lte);
                            update.setDate(update.getDate() + 1);
                            const formattedDate = update
                              .toISOString()
                              .split("T")[0];
                            const filterStartDate = {
                              createdAt: {
                                $lte: formattedDate,
                                $gte: filterObj.createdAt.$gte,
                              },
                            };
                            this.searchSubmit(filterStartDate);
                            this.setState({ filters: filterStartDate });
                          } catch (e) {
                            this.searchSubmit({});
                            this.setState({ filters: {} });
                          }
                        }}
                      />
                    </div>
                    <div className="col-lg-8 d-flex align-items-center p-0">
                      <label className="fw-bold ms-auto">
                        TOTAL APPLICANTS: {this.state.totalObject || 0}
                      </label>
                    </div>
                  </div>
                </div>
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center justify-content-between">
                    <h4 className="text-primary">{schema.label}</h4>
                    <div className="d-flex gap-2">
                      <Button
                        onClick={() => this.presenter.getGenerateXLSX(schema)}
                      >
                        Export XLSX
                      </Button>

                      <Button
                        onClick={this.UpdateStatus.bind(this)}
                        disabled={
                          Array.isArray(selected) && !selected.length > 0
                        }
                      >
                        Update Status
                      </Button>
                      {/* <Button
                        onClick={this.ScheduleApplicant.bind(this)}
                        disabled={
                          Array.isArray(selected) && !selected.length > 0
                        }
                      >
                        Schedule Interview
                      </Button> */}
                      <div
                        style={{
                          position: "relative",
                          display: "inline-block",
                        }}
                      >
                        <Button
                          onClick={this.ScheduleApplicant.bind(this)}
                          disabled={
                            Array.isArray(selected) &&
                            // !selected.length > 0 &&
                            (selected.some(
                              (applicant) =>
                                applicant.status === "Hired" ||
                                applicant.status === "Rejected"
                            ) ||
                              !selected.length > 0)
                          }
                          onMouseEnter={this.handleMouseEnter}
                          onMouseLeave={this.handleMouseLeave}
                          style={{
                            cursor: hasInvalidStatus
                              ? "not-allowed"
                              : "pointer",
                            padding: "10px 20px",
                            // backgroundColor: hasInvalidStatus
                            //   ? "#ccc"
                            //   : "#007bff",
                            // color: "#fff",
                            border: "none",
                            borderRadius: "5px",
                            fontSize: "16px",
                          }}
                        >
                          Schedule Interview
                        </Button>
                        {showTooltip && (
                          <div
                            style={{
                              position: "absolute",
                              top: "-70px",
                              left: "0",
                              backgroundColor: "black",
                              color: "white",
                              padding: "5px 10px",
                              // marginRight: "100px",
                              borderRadius: "5px",
                              fontSize: "12px",
                              whiteSpace: "nowrap",
                              zIndex: 1000,
                              boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.5)",
                            }}
                          >
                            Some applicants have a status of
                            <br /> 'Hired' or 'Rejected' and cannot <br /> be
                            scheduled for an interview.
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                ofAppearance={this.UpdateStatus.bind(this)}
                hrAction={this.handleViewData.bind(this)}
                ofTraining={this.ScheduleApplicant.bind(this)}
                refetch={this.refetchData.bind(this)}
                objectData={this.handlePrintBtn.bind(this)}
                printTraining={this.handleGenerateCSV.bind(this)}
                progress={loading}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-three-dots-vertical" />,
                    actionType: "applicant",
                  },
                ]}
                selectable
                // collapsable
                excludeFields={Object.keys(schema.fields).reduce((acc, key) => {
                  const options = schema.fields[key];
                  if (options.read === false) {
                    acc.push(key);
                  }
                  switch (options._type || options.type) {
                    case "Relation":
                    case "Array":
                    case "File":
                      acc.push(key);
                      break;
                    default:
                  }
                  return acc;
                }, includeTable)}
                // onClickItem={this.onClickItem.bind(this)}
                selected={selected}
                onSelect={this.onSelect.bind(this)}
                onSelectAll={this.onSelectAll.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
        {this.state.isStatusClicked && (
          <UpdateObjectStatus
            handleFloatingClose={(field) => this.handleFloatingClose(field)}
            allEmployee={this.state.allEmployee}
            selected={selected}
            showError={(error) => this.showError(error)}
            refetchData={() => this.refetchData()}
          />
        )}

        {this.state.isScheduleClicked && (
          <SetApplicantSchedule
            handleFloatingClose={(field) => this.handleFloatingClose(field)}
            // object={this.state.object}
            object={selected}
            showSuccess={(message) => this.showSuccess(message)}
            refetchData={() => this.refetchData()}
          />
        )}
      </>
    );
  }
}

export default withRouter(JobApplicantsPage);
